module.exports = __webpack_public_path__ + "img/221121-bimistock-------3@1x.efe766d0.png";